import { Route, Switch } from 'react-router-dom'

import Consent from './consent'
import SignIn from './signin'

const Routes = () => {
  return (
    <>
      <Switch>
        <Route path="/oauth2/consent">
          <Consent
            clientName="CGN"
            clientDescription="CGN is an integrated college and career solution that leads students and families through the entire college and career planning process."
            infoLink="https://www.scoir.com/cgnpartnership"
          />
        </Route>
        <Route path="/oauth2/signin">
          <SignIn />
        </Route>
      </Switch>
    </>
  )
}

export default Routes
